import { defineMessages } from "./define.js";

/** The file strip: tiles, the upload in flight, and everything that can go wrong. */
export const attachments = defineMessages("attachments", {
  // A file whose name cannot be read — an e2ee blob, or one written by a newer
  // client — still gets a tile rather than an empty square.
  fileFallback: { ru: "Файл", en: "File" },

  open: { ru: "Открыть «{name}»", en: "Open “{name}”" },

  // The full-screen viewer for a picture. «Поделиться» is the system sheet —
  // where "Сохранить в фото" and "Скопировать" actually live — so the word is
  // the one the phone itself uses, not a description of what it opens.
  viewing: { ru: "Просмотр «{name}»", en: "Viewing “{name}”" },
  share: { ru: "Поделиться", en: "Share" },
  save: { ru: "Сохранить", en: "Save" },
  /* Короткое намеренно: три действия делят ширину телефона, и «Открыть в
     браузере» обрезалось бы на узком экране — обрезанная подпись хуже краткой. */
  openInBrowser: { ru: "В браузере", en: "In the browser" },
  shareFailed: { ru: "Не удалось поделиться файлом", en: "Could not share the file" },

  remove: { ru: "Удалить «{name}»", en: "Delete “{name}”" },
  addFile: { ru: "Добавить файл", en: "Add a file" },

  // The composer's side of it: a file chosen, but not yet sent with anything.
  // «Убрать», not «удалить» — nothing has been uploaded yet to delete.
  attach: { ru: "Прикрепить файл", en: "Attach a file" },
  picked: { ru: "Файлы к сообщению", en: "Files for this message" },
  unpick: { ru: "Убрать «{name}»", en: "Remove “{name}”" },

  // The units are read, so they are translated too. The number itself is
  // formatted by `Intl` — the decimal separator follows the language with it.
  sizeBytes: { ru: "{size} Б", en: "{size} B" },
  sizeKilobytes: { ru: "{size} КБ", en: "{size} KB" },
  sizeMegabytes: { ru: "{size} МБ", en: "{size} MB" },

  uploading: { ru: "Загружается «{name}», {percent}%", en: "Uploading “{name}”, {percent}%" },
  /* Ожидание — не провал: байты уже на устройстве и уйдут сами. Нолём процентов
     это читается как загрузка, которая сдалась. */
  waitingForNetwork: {
    ru: "«{name}» ждёт сети — уйдёт, когда она появится",
    en: "“{name}” is waiting for a network — it will go when one appears",
  },
  waitingShort: { ru: "Ждёт сети", en: "Waiting" },

  // In an encrypted space a file is downloaded and opened on the device before
  // it can be shown at all, so the tile has a state between empty and there.
  opening: { ru: "Файл открывается", en: "Opening the file" },
  // No key, somebody else's key, or bytes that did not survive the trip —
  // nothing here can tell those apart, and none of them has a different answer.
  unreadable: { ru: "Файл не читается", en: "The file won't open" },


  dismissError: { ru: "{error}. Убрать", en: "{error}. Dismiss" },
  tapToDismiss: { ru: "нажмите, чтобы убрать", en: "tap to dismiss" },

  errorOffline: {
    ru: "Нет соединения — файл можно отправить только онлайн",
    en: "No connection — a file can only go up online",
  },
  errorUnsupported: {
    ru: "Такой файл прикрепить нельзя — только картинки и PDF",
    en: "That file can't be attached — pictures and PDFs only",
  },
  errorTooLarge: { ru: "Файл больше {size} МБ", en: "The file is over {size} MB" },
  // The space is locked on this device: refusing is the only answer, because
  // the alternative is the file going up readable into an encrypted space.
  errorSealFailed: {
    ru: "Не удалось зашифровать файл — пространство закрыто на этом устройстве",
    en: "Could not encrypt the file — this space is locked on this device",
  },
  errorEmptyFile: { ru: "Файл пустой", en: "The file is empty" },
  errorSessionExpired: {
    ru: "Сессия истекла — войдите заново",
    en: "Your session expired — sign in again",
  },
  errorTargetGone: { ru: "Запись уже удалили", en: "That entry is already gone" },
  errorUploadFailed: { ru: "Не удалось загрузить файл", en: "Could not upload the file" },
  // A file that waited for a network, got one, and still could not be sent —
  // several times over. Said as a fact with a way forward, not as a shrug: the
  // person still has the photograph, and picking it again is all it takes.
  errorGaveUp: {
    ru: "Файл так и не ушёл — попробуйте отправить его заново",
    en: "The file never went up — try sending it again",
  },
  errorBadResponse: {
    ru: "Сервер ответил неожиданным образом",
    en: "The server answered in a way we did not expect",
  },
  errorRemoveFailed: { ru: "Не удалось удалить вложение", en: "Could not delete the attachment" },
});
